module.exports = __webpack_public_path__ + "static/partner-1-23a847d9be4f0b7308f11159e01ffd5c.png";